import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { useScreenSize } from 'src/customHooks/customHooks'
import { getImageLink, getImageLinkWithUnsplash } from 'src/mentor/helpers/utilityFunctions'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import { LoadingSpinner } from '../Loaders'
import PrewallAndPaywall from '../PrewallAndPaywall/PrewallAndPaywall'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import PracticeTimer from '../TimerComponent/PracticeTimer'
import { TimerPageContainer } from './components/styledComponents'
import { getPracticeTimerById, getPracticeTimerBySlug } from './utils'

export default function TimersPage({ type = 'slug' }) {
  const navigate = useNavigate()
  const { state } = useLocation()

  const [searchParams] = useSearchParams()
  const src = searchParams.get('src')
  const srcId = searchParams.get('src-id')
  const { width } = useScreenSize()

  const { id } = useParams()

  const { profileData } = useContext(ProfileContext)
  const { setupData } = useContext(SetupContext)

  const [practiceTimer, setPracticeTimer] = useState()

  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [prewallOpen, setPrewallOpen] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')
  const [loading, setLoading] = useState(false)
  const [bgImgUrl, setBgImgUrl] = useState(
    'https://images.unsplash.com/photo-1713903748969-fd089c74fc07?q=80&w=2075&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  )

  async function GetPracticeTimer() {
    // const response = await getDataWithParams('add url', {})
    // if (response.status === 200) {
    //   if (isCommonResponseSuccessful(response.data.code)) {
    //     setPracticeTimer(response.data.practice)
    //   }
    // }
    var timerData = null
    if (!!state && !!state?.item) {
      setPracticeTimer(state.item)
      timerData = state.item
    } else {
      const apiFUnctionToUse = type === 'slug' ? getPracticeTimerBySlug : getPracticeTimerById

      const timerResp = await apiFUnctionToUse(id)

      setPracticeTimer(timerResp.data)
      timerData = timerResp.data
    }

    ///SETTING UP THE BACKGROUND IMAGE
    const url = await getImageLinkWithUnsplash(undefined, undefined, {
      unSplashParamsOverride: {
        orientation: width > 768 ? 'landscape' : 'portrait',
      },
      useUnsplashImage: true,
    })
    setBgImgUrl(url)
  }

  async function Setup() {
    setLoading(true)
    await GetPracticeTimer()
    setLoading(false)
  }

  function handleStartTimer(startFunction) {
    if (isTokenInvalidOrAbsent(localStorage.getItem('token'))) {
      setShowClubbedAuthModal(true)
    } else {
      // setPrewallOpen(true)
      startFunction()
    }
  }

  useEffect(() => {
    Setup()
  }, [])

  useEffect(() => {
    console.log({ practiceTimer })
  }, [practiceTimer])

  return (
    <>
      <SEOComponent
        title={`Timer | ${practiceTimer?.title}`}
        description={`Go through this ${practiceTimer?.title} course.`}
        image={practiceTimer && getImageLink(practiceTimer?.coverIcon)}
      />
      {loading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <div className="d-flex flex-column" style={{ height: '100vh' }}>
            <PublicAppHeader
              loginFunction={() => {
                setTypeOfClubbedAuthModal('login')
                setShowClubbedAuthModal(true)
              }}
              registerFunction={() => {
                setTypeOfClubbedAuthModal('signup')
                setShowClubbedAuthModal(true)
              }}
              config={{ showLinks: false }}
              propUserProfileData={profileData}
            />
            <ClubbedAuthModal
              open={showClubbedAuthModal}
              onClose={() => {
                setShowClubbedAuthModal(false)
              }}
              loginVariant={typeOfClubbedAuthModal === 'login'}
            />
            {/* <InfoAndSingleActionComponentVarOne
            headline={practiceTimer?.title}
            description={practiceTimer?.shortDesc}
            image={getImageLink(practiceTimer?.coverIcon, defaultBgImgId)}
            actionButtonText="Play"
            clickFunction={() => handleStartTimer()}
          /> */}
            <TimerPageContainer bgImgUrl={bgImgUrl}>
              <PracticeTimer
                src={src}
                srcId={srcId}
                timerId={practiceTimer?.id}
                title={practiceTimer?.title}
                description={practiceTimer?.description}
                bellType={practiceTimer?.bellType}
                intervals={practiceTimer?.intervals}
                duration={practiceTimer?.duration}
                durationType={practiceTimer?.durationType}
                maxDuration={practiceTimer?.maxDuration}
                minDuration={practiceTimer?.minDuration}
                timerBackground={practiceTimer?.coverImage}
                beginButtonOverride={handleStartTimer}
              />
            </TimerPageContainer>
            {/* <RelatedAppFeaturesComponent domainsArray={[]} featuresArrayInOrder={['mentor']} /> */}
            {/* <FaqSection categoryIds={[FAQ_CATEGORIES.therapist_booking_page_faqs]} /> */}
            <PrewallAndPaywall
              id="journal_play"
              secureData={setupData}
              wallIsOpen={prewallOpen}
              toggleWall={() => {
                setPrewallOpen((prev) => !prev)
              }}
            />
          </div>
          {/* <PublicAppFooter /> */}
        </>
      )}
    </>
  )
}
